// Profil / Niveau / XP — Checkpoint
// Niveau infini, courbe linéaire-cumulative.
// Le rang (Bronze → Légende) est conservé séparément pour le futur PvP.

/**
 * XP nécessaire pour passer du niveau L au niveau L+1.
 * Courbe douce mais qui augmente toujours : 100 * L.
 *   L 1 → 2 :  100
 *   L 2 → 3 :  200
 *   L 5 → 6 :  500
 *   L 10 → 11 : 1000
 *   L 50 → 51 : 5000
 */
export const xpToNextLevel = (level) => 100 * Math.max(1, level);

/**
 * Calcule {level, currentXP, neededXP, progress%} à partir du XP total cumulé.
 * Pas de cap : niveau infini.
 */
export const computeLevel = (totalXp = 0) => {
  let level = 1;
  let xp = Math.max(0, Math.floor(totalXp));
  while (xp >= xpToNextLevel(level)) {
    xp -= xpToNextLevel(level);
    level += 1;
  }
  const needed = xpToNextLevel(level);
  const progress = Math.min(100, Math.max(0, (xp / needed) * 100));
  return { level, currentXP: xp, neededXP: needed, progress };
};

/**
 * Déblocage des classes par niveau de profil.
 * Le Duelliste est toujours disponible (start de l'aventure).
 */
export const CLASS_UNLOCK_LEVEL = {
  duelliste: 1,
  eclaireur: 3,
  heros: 6,
  oracle: 10,
  libromancien: 15,
  berger: 20,
};

/**
 * Classes débloquables UNIQUEMENT à l'achat (or de boutique persistant), jamais par niveau.
 * unlockId = identifiant stocké dans `cosmetics_owned` (réutilise le système d'achat existant).
 */
export const PURCHASE_ONLY_CLASSES = {
  builder: { unlockId: "class_builder", cost: 30000 },
};

export const isClassUnlocked = (classeId, profileLevel = 1, ownedUnlocks = []) => {
  const purchase = PURCHASE_ONLY_CLASSES[classeId];
  if (purchase) return (ownedUnlocks || []).includes(purchase.unlockId);
  return profileLevel >= (CLASS_UNLOCK_LEVEL[classeId] ?? 1);
};

/**
 * Quelques sources d'XP standard.
 * Le backend recalcule mais on partage la liste pour transparence côté UI.
 */
export const XP_REWARDS = {
  combat_won: (floor = 1) => 3 + Math.floor(floor * 0.5),
  elite_won:  (floor = 1) => 8 + floor,
  boss_won:   (floor = 1) => 18 + floor * 2,
  chest_opened: 2,
  sanctuary_visited: 2,
  floor_cleared: 9,
  // Achievements give their FULL points value as XP (no rank points)
  achievement_unlock: (points = 0) => points,
};
